import { createApi } from '@reduxjs/toolkit/query/react'
import type { DeleteProfileApiResponse, ProfileApiResponse, UpdateProfileRequest, UploadAvatarRequest } from '@/types/profile'
import { playerBaseQuery } from './playerBaseQuery'

export const profileApi = createApi({
	reducerPath: 'profileApi',
	baseQuery: playerBaseQuery,
	tagTypes: ['Profile'],
	endpoints: (builder) => ({
		getProfile: builder.query<ProfileApiResponse, void>({
			query: () => '/profile',
			providesTags: ['Profile'],
		}),
		updateProfile: builder.mutation<ProfileApiResponse, UpdateProfileRequest>({
			query: (body) => ({
				url: '/profile',
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['Profile'],
		}),
		deleteProfile: builder.mutation<DeleteProfileApiResponse, void>({
			query: () => ({
				url: '/profile',
				method: 'DELETE',
			}),
		}),
		uploadAvatar: builder.mutation<ProfileApiResponse, UploadAvatarRequest>({
			query: (body) => ({
				url: '/profile/avatar',
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['Profile'],
		}),
	}),
})

export const { useGetProfileQuery, useUpdateProfileMutation, useDeleteProfileMutation, useUploadAvatarMutation } = profileApi
